import { AfterViewInit, Component, OnInit } from '@angular/core';
import { GoogleTagService } from './core/services/google-tag/google-tag.service';
import { IframeAdapterService } from './core/services/iframe/iframe-adapter.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements AfterViewInit, OnInit {
  observer!: ResizeObserver;
  container!: HTMLElement;

  constructor(
    private iframeAdapter: IframeAdapterService,
    private gtmService: GoogleTagService
  ) {}

  ngOnInit(): void {
    localStorage.clear();
    this.gtmService.gtmSetup();
  }

  ngAfterViewInit(): void {
    this.observeScrollHeight();
  }

  observeScrollHeight() {
    this.container = document.getElementById('clave-web-pyme-content')!;
    const observer = new ResizeObserver(() => {
      this.iframeAdjustement();
    });
    observer.observe(this.container);
  }

  iframeAdjustement() {
    this.iframeAdapter.sendIframeHeight();
  }
}
